<div class="manual-assignment">
  <div
    class="d-flex align-items-center justify-content-center manual-assignment__file-upload"
    [class.document-upload]="fileType === types.FILE_UPLOAD">
    @switch (fileType) {
      @case (types.VIDEO) {
        <app-video-record
          [maxVideoLength]="question.maxDuration ? question.maxDuration * 60 : null"
          [canUpload]="question.allowUploadFile"
          [previewMode]="previewMode"
          (videoRecorded)="fileChanged($event)">
        </app-video-record>
      }
      @case (types.AUDIO) {
        <app-audio-record
          [audioMaxLength]="question.maxDuration ? question.maxDuration * 60 : null"
          [canUpload]="question.allowUploadFile"
          (audioRecorded)="fileChanged($event)"
          [previewMode]="previewMode">
        </app-audio-record>
      }
      @case (types.SCREEN) {
        <app-video-record
          recordType="screen"
          [maxVideoLength]="question.maxDuration ? question.maxDuration * 60 : null"
          [canUpload]="question.allowUploadFile"
          (videoRecorded)="fileChanged($event)"
          [previewMode]="previewMode">
        </app-video-record>
      }
      @case (types.IMAGE) {
        <div class="upload-file-container">
          <app-manual-assessment-file-upload
            allowedExtensions="image/png, image/jpeg"
            [multiple]="true"
            [assessmentType]="fileType"
            (fileSelected)="fileChanged($event)">
          </app-manual-assessment-file-upload>
          @if (form.get('file')?.value) {
            <div class="input-group" [formGroup]="form">
              <textarea
                type="text"
                [placeholder]="'SLIDES.briefly_summarize_your_assessment' | translate"
                formControlName="text"
                class="textarea">
              </textarea>
            </div>
          }
        </div>
      }
      @case (types.TEXT) {
        <div class="input-group text-only" [formGroup]="form">
          <textarea
            type="text"
            [placeholder]="'SLIDES.briefly_summarize_your_assessment' | translate"
            formControlName="text"
            class="textarea">
          </textarea>
        </div>
      }
      @default {
        <div class="upload-file-container">
          <app-manual-assessment-file-upload
            (fileSelected)="fileChanged($event)"
            [allowedExtensions]="question.allowedFileExtensions"
            [maxAllowedFileSizeInMb]="question.fileSize"
            [assessmentType]="fileType">
          </app-manual-assessment-file-upload>
          @if (form.get('file')?.value) {
            <div class="input-group" [formGroup]="form">
              <textarea
                type="text"
                [placeholder]="'SLIDES.briefly_summarize_your_assessment' | translate"
                formControlName="text"
                class="textarea">
              </textarea>
            </div>
          }
        </div>
      }
    }

  </div>
</div>